import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.iterator.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { reactive, toRefs, computed } from "vue";
import { getDefaultSearchBean } from "@wikicasa/common/model/RealEstateSearchBean";
//@ts-ignore
import { ENERGY_CLASS } from "@customTypes/EnergyClass";
//@ts-ignore
import { isArrNullOrEmpty } from "@utils/ArrayUtils";
//@ts-ignore
import { deepCopy } from "@utils/ObjectUtils";
//@ts-ignore
import { PLACE_TYPE } from "@customTypes/PlaceType";
export function usePlaceType() {
  var _this = this;
  var state = reactive({
    localityList: [],
    /**
     * The zone list resulting from the city search
     * */
    zoneList: [],
    searchBeanModal: getDefaultSearchBean(),
    prevSelectedLocality: undefined,
    //TODO: valutare se inserirlo solo in placeModal
    localitySelected: undefined,
    prevZoneIDsSelected: undefined,
    //TODO: valutare se inserirlo solo in placeModal
    /**
     * The zone ids checked (from the dropdown)
     * */
    zoneIDsSelected: [],
    zoneModifiedByUser: false,
    districtSelected: {},
    districtsObj: {},
    lastInsertedZone: 0
  });
  var isSingleDistrictSelected = computed(() => {
    return selectedDistrictLength.value === 1;
  });
  var isAnyDistrictSelected = computed(() => {
    return Object.keys(state.districtSelected).length > 0;
  });
  var selectedDistrictLength = computed(() => {
    return Object.values(state.districtSelected).reduce((prev, cur) => {
      return prev + cur.length;
    }, 0);
  });
  var partialSelectedDistrictLength = computed(() => {
    return Object.entries(state.districtSelected).reduce((prev, _ref) => {
      var [zoneId, districts] = _ref;
      var totalDistrictLength = getDistrictLengthByZoneId(+zoneId);
      if (totalDistrictLength === districts.length) return prev;
      return prev + districts.length;
    }, 0);
  });
  var allDistrictSelectedPerZone = computed(() => {
    if (!isAnyDistrictSelected.value) {
      return false;
    }
    for (var zoneId in state.districtSelected) {
      var districtSelectedLength = state.districtSelected[zoneId].length;
      var districtLength = state.districtsObj[zoneId].length;
      if (districtSelectedLength !== districtLength) return false;
    }
    return true;
  });
  var convertEnergyClassFilter = () => {
    switch (state.searchBeanModal.energyClassFilter) {
      case "HIGH":
        {
          state.searchBeanModal.energyClassFilter = ENERGY_CLASS.HIGH;
          break;
        }
      case "MEDIUM":
        {
          state.searchBeanModal.energyClassFilter = ENERGY_CLASS.MEDIUM;
          break;
        }
      case "LOW":
        {
          state.searchBeanModal.energyClassFilter = ENERGY_CLASS.LOW;
          break;
        }
    }
  };
  var convertFloor = () => {
    state.searchBeanModal.floor = state.searchBeanModal.floorId;
  };
  /* SearchBeanModal handling */
  var resetSearchBeanZonesAndLocalities = () => {
    state.zoneList = [];
    state.zoneIDsSelected = [];
    state.districtSelected = {};
    state.localitySelected = undefined;
    state.searchBeanModal.zoneIdList = [];
    state.searchBeanModal.localityIdList = [];
    state.searchBeanModal.districtIdList = [];
    state.searchBeanModal.zoneId = null;
    state.searchBeanModal.zoneURL = null;
    state.searchBeanModal.districtId = null;
    state.searchBeanModal.districtURL = null;
  };
  var updateSearchModal = searchBean => {
    var _searchBean = deepCopy(searchBean);
    if (!_searchBean) throw new Error("_searchBean is null");
    state.searchBeanModal = _searchBean;
  };
  var updateSearchModalByPlace = plc => {
    state.searchBeanModal.areaOfInterestId = plc.areaOfInterestID;
    state.searchBeanModal.cityURL = plc.cityURL;
    state.searchBeanModal.cityDisplayName = plc.displayName;
    state.searchBeanModal.cityId = plc.cityID;
    state.searchBeanModal.placeType = plc.placeType;
    state.searchBeanModal.placeId = plc.placeID;
    state.searchBeanModal.provinceId = plc.provinceID;
    state.searchBeanModal.regionId = plc.regionID;
    state.searchBeanModal.zoneId = plc.zoneID;
    state.searchBeanModal.zoneIdList = [];
    state.searchBeanModal.localityIdList = [];
    state.searchBeanModal.polygonFromMap = "";
    state.searchBeanModal.polygonForDB = "";
    state.searchBeanModal.localityIdList = [];
    state.searchBeanModal.zoneURL = plc.zoneURL;
    state.searchBeanModal.districtId = plc.districtID;
    //The zoneIDList is used to update the counter!
    if (plc.zoneID) state.searchBeanModal.zoneIdList = [plc.zoneID];
    //Same for the localityIdList!
    if (plc.localityID) state.searchBeanModal.localityIdList = [plc.localityID];
    if (plc.placeType === PLACE_TYPE.DISTRICT) {
      state.searchBeanModal.districtIdList = [plc.districtID];
      state.searchBeanModal.districtId = plc.districtID;
      state.searchBeanModal.zoneId = null;
      state.searchBeanModal.zoneIdList = [];
    }
  };
  var updateSearchModalAndPlace = (plc, updatePlace) => {
    updateSearchModalByPlace(plc);
    updatePlace();
  };
  var fixSearchBean = (updateZoneCb, updateLocationCb, updateDistrictCb) => {
    var {
      localityIdList,
      zoneIdList,
      districtIdList
    } = state.searchBeanModal;
    if (localityIdList && localityIdList.length) {
      state.searchBeanModal.localityIdList = [...localityIdList];
      state.searchBeanModal.zoneURL = updateLocationCb();
      return;
    }
    if (zoneIdList) {
      if (zoneIdList.length == 1) {
        state.searchBeanModal.zoneId = zoneIdList[0];
        state.searchBeanModal.zoneIdList = [];
        state.searchBeanModal.zoneURL = updateZoneCb();
      } else if (zoneIdList.length > 1) {
        // remove duplicate IDS
        state.searchBeanModal.zoneIdList = [...new Set(state.searchBeanModal.zoneIdList)];
        state.searchBeanModal.zoneURL = null;
        state.searchBeanModal.zoneId = null;
      }
    } else if (districtIdList) {
      if (districtIdList.length == 1) {
        state.searchBeanModal.districtId = districtIdList[0];
        state.searchBeanModal.districtIdList = [];
        state.searchBeanModal.districtURL = updateDistrictCb();
      } else if (districtIdList.length > 1) {
        // remove duplicate IDS
        //state.searchBeanModal.districtIdList = [...new Set(state.searchBeanModal.districtIdList)];
        state.searchBeanModal.districtURL = null;
        state.searchBeanModal.districtId = null;
      }
    } else {
      state.searchBeanModal.zoneURL = null;
      state.searchBeanModal.zoneId = null;
      state.searchBeanModal.districtURL = null;
      state.searchBeanModal.districtId = null;
    }
  };
  /* Zone and Location handling */
  var initZonesAndLocalities = function initZonesAndLocalities(placesPromise) {
    var onSuccess = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    var onFailure = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
    return __awaiter(_this, void 0, void 0, function* () {
      var _a;
      var places = yield placesPromise;
      if (!places || places.length <= 0) {
        onFailure && onFailure();
        // throw new Error("empty or null places");
      }
      var localities = [];
      var zones = [];
      places.forEach(p => {
        if (p.zoneID) zones.push(p);else if (p.localityID) localities.push(p);
      });
      state.localityList = localities;
      state.zoneList = zones;
      var selectedDistrictIds = 0;
      state.districtsObj = {};
      state.districtSelected = {};
      var _loop = function* _loop(zone) {
        //If there are no districts, we continue our loop
        if (zone.subPlaces.length <= 0) return 1; // continue
        // $set(state.districtsObj, zone.zoneID, zone.subPlaces)
        state.districtsObj[zone.zoneID] = zone.subPlaces;
        if (selectedDistrictIds < (((_a = state.searchBeanModal.districtIdList) === null || _a === void 0 ? void 0 : _a.length) || -1))
          //Initializing districts selected
          state.districtsObj[zone.zoneID].forEach(district => {
            var _a;
            if ((_a = state.searchBeanModal.districtIdList) === null || _a === void 0 ? void 0 : _a.includes(district.districtID)) {
              insertDistrictByZoneId(zone.zoneID, district.districtID);
              ++selectedDistrictIds;
            }
          });
      };
      for (var zone of zones) {
        if (yield* _loop(zone)) continue;
      }
      onSuccess && onSuccess();
    });
  };
  var areAllDistrictsSelected = zoneId => {
    return state.zoneIDsSelected.includes(zoneId);
  };
  var isSingleDistrictByZoneId = zoneId => {
    if (!state.districtSelected[zoneId]) return false;
    return state.districtSelected[zoneId].length === 1;
  };
  var isZoneOrLocalitySelected = () => {
    return state.zoneIDsSelected.length > 0 || state.localitySelected != null;
  };
  var isZoneWithoutDistrict = zoneId => {
    return !Object.keys(state.districtsObj).includes("".concat(zoneId));
  };
  var areZonesAndLocalitiesEmpty = () => {
    return isArrNullOrEmpty(state.zoneList) && isArrNullOrEmpty(state.localityList);
  };
  var areZonesAndLocalitiesFilled = () => {
    return !isArrNullOrEmpty(state.zoneList) && !isArrNullOrEmpty(state.localityList);
  };
  var getSingleSelectedZone = () => {
    if (state.zoneIDsSelected.length !== 1 && !state.searchBeanModal.zoneId) return null;
    var currentZoneID = state.zoneIDsSelected.length == 1 ? state.zoneIDsSelected[0] : state.searchBeanModal.zoneId;
    return getZoneById(currentZoneID);
  };
  var getSingleSelectedDistrict = () => {
    var _a;
    if (Object.keys(state.districtSelected).length !== 1 && (((_a = state.searchBeanModal.districtIdList) === null || _a === void 0 ? void 0 : _a.length) !== 1 || !state.searchBeanModal.districtId)) return null;
    var districtSelectedKeys = Object.keys(state.districtSelected);
    var singleZoneId = districtSelectedKeys[0];
    return getDistrictById(+singleZoneId, Object.values(state.districtSelected)[0][0]);
  };
  var getZoneById = zoneID => {
    if (!zoneID) return null;
    for (var plc of state.zoneList) if (plc.zoneID === zoneID) {
      return plc;
    }
    return null;
  };
  var getDistrictById = (zoneId, districtID) => {
    if (!districtID || !zoneId) {
      return null;
    }
    for (var plc of state.districtsObj[zoneId]) if (plc.districtID === districtID) {
      return plc;
    }
    return null;
  };
  var getDistrictLengthByZoneId = zoneId => {
    return state.districtsObj[zoneId].length;
  };
  var getDistrictSelectedLengthByZoneId = zoneId => {
    if (!state.districtSelected[zoneId]) return null;
    return state.districtSelected[zoneId].length;
  };
  var resetZoneAndLocalities = () => {
    if (isArrNullOrEmpty(state.zoneList) && isArrNullOrEmpty(state.localityList)) {
      return;
    }
    state.zoneList = [];
    state.localityList = [];
  };
  var addZone = (zone, updatePlaceNameAction) => {
    state.zoneIDsSelected = [...state.zoneIDsSelected, zone.zoneID];
    state.lastInsertedZone = zone.zoneID;
    addDistrict(zone, updatePlaceNameAction);
    if (state.searchBeanModal.zoneIdList) state.searchBeanModal.zoneIdList = [...state.searchBeanModal.zoneIdList, zone.zoneID];
    state.zoneModifiedByUser = true;
    if (state.zoneIDsSelected.length === 1) {
      state.searchBeanModal.zoneURL = zone.zoneURL;
      state.searchBeanModal.zoneId = zone.zoneID;
    } else {
      state.searchBeanModal.zoneURL = null;
      state.searchBeanModal.zoneId = null;
    }
    updatePlaceNameAction();
  };
  var removeZone = function removeZone(zone, updatePlaceNameAction) {
    var isDistrict = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var _a, _b;
    state.zoneIDsSelected = state.zoneIDsSelected.filter(id => id !== zone.zoneID) || [];
    if (!isDistrict) removeDistrict(zone, updatePlaceNameAction);
    state.searchBeanModal.zoneIdList = ((_b = (_a = state.searchBeanModal) === null || _a === void 0 ? void 0 : _a.zoneIdList) === null || _b === void 0 ? void 0 : _b.filter(id => id !== zone.zoneID)) || [];
    state.searchBeanModal.zoneId = null;
    state.searchBeanModal.zoneURL = null;
    state.zoneModifiedByUser = true;
    if (state.zoneIDsSelected.length === 1) {
      var singleZone = state.zoneList.find(z => z.zoneID === state.zoneIDsSelected[0]);
      if (singleZone) {
        state.searchBeanModal.zoneURL = singleZone.zoneURL;
        state.searchBeanModal.zoneId = singleZone.zoneID;
      }
    }
    updatePlaceNameAction();
  };
  var isZoneSelected = zoneId => {
    var _a;
    return state.zoneIDsSelected.includes(zoneId) || !!((_a = state.districtsObj[zoneId]) === null || _a === void 0 ? void 0 : _a.find(district => {
      var _a;
      return (_a = state.districtSelected[zoneId]) === null || _a === void 0 ? void 0 : _a.includes(district.districtID);
    }));
  };
  var isLocationSelected = locationId => {
    var _a;
    return ((_a = state.localitySelected) === null || _a === void 0 ? void 0 : _a.localityID) === locationId;
  };
  var isDistrictSelected = (zoneId, districtId) => {
    if (!state.districtSelected[zoneId]) return false;
    return state.districtSelected[zoneId].includes(districtId);
  };
  /**
   * Add a single location to the zoneIdSelected list.
   * This method ensures that the zoneIdSelected list will contain ONLY the locationId passed as input parameter
   * */
  var addLocation = (place, updatePlaceNameAction) => {
    state.zoneIDsSelected = [];
    state.searchBeanModal.zoneIdList = [];
    /*
            if(state.localitySelected !== undefined)
                $set(state.localitySelected, "localitySelected", place as Place)*/
    state.localitySelected = place;
    if (state.searchBeanModal) {
      state.searchBeanModal.localityIdList = [place.localityID];
      state.searchBeanModal.zoneURL = place.zoneURL;
    }
    state.zoneModifiedByUser = true;
    updatePlaceNameAction();
  };
  var removeLocation = updatePlaceNameAction => {
    state.localitySelected = undefined;
    state.searchBeanModal.localityIdList = [];
    state.searchBeanModal.zoneURL = "";
    state.zoneModifiedByUser = true;
    updatePlaceNameAction();
  };
  var insertDistrictByZoneId = (zoneId, districtId) => {
    if (!state.districtSelected[zoneId]) {
      // $set(state.districtSelected, `${zoneId}`, [districtId])
      state.districtSelected[zoneId] = [districtId];
    } else {
      state.districtSelected[zoneId] = [...state.districtSelected[zoneId], districtId];
    }
  };
  var insertBulkDistrictByZoneId = (zoneId, districtId) => {
    // $set(state.districtSelected, `${zoneId}`, districtId)
    state.districtSelected[zoneId] = districtId;
  };
  var onPlaceLIClick = function onPlaceLIClick(place, updatePlaceNameAction) {
    var isLocation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    //Sebastian R.S: If we select a zone, we want to remove the ONLY selected locality if present
    if (place.zoneID && state.localitySelected) removeLocation(updatePlaceNameAction);
    if (isLocation) addLocation(place, updatePlaceNameAction);else {
      isZoneSelected(place.zoneID) ? removeZone(place, updatePlaceNameAction) : addZone(place, updatePlaceNameAction);
    }
  };
  var onDistrictClick = (zone, district, updatePlaceNameAction) => {
    state.lastInsertedZone = zone.zoneID;
    if (isDistrictSelected(district.zoneID, district.districtID) || areAllDistrictsSelected(zone.zoneID)) removeDistrict(zone, updatePlaceNameAction, district);else addDistrict(zone, updatePlaceNameAction, district);
  };
  var addDistrict = (zone, updatePlaceNameAction, district) => {
    var _a, _b, _c, _d, _e, _f;
    if (!district) {
      return;
    }
    //Cleaning up the zoneUrl
    state.searchBeanModal.zoneURL = null;
    state.searchBeanModal.zoneId = null;
    //If almost all the districts are selected, before the insert of the current district...
    if (getDistrictLengthByZoneId(zone.zoneID) - 1 === ((_a = state.districtSelected[zone.zoneID]) === null || _a === void 0 ? void 0 : _a.length)) {
      addZone(zone, updatePlaceNameAction);
      if (!state.searchBeanModal.districtIdList) return;
      //Removing all the districts previously selected for the specific zone
      state.searchBeanModal.districtIdList = state.searchBeanModal.districtIdList.filter(districtID => !state.districtsObj[zone.zoneID].find(district => district.districtID == districtID));
      //Removing the zoneId and its districts from districtSelected
      // $delete(state.districtSelected, zone.zoneID)
      delete state.districtSelected[zone.zoneID];
    }
    //In any other scenario, we will normally add the districts
    else {
      //By default, we remove the zoneId of the district from the searchBeanModal
      var zoneIdxToRemove = (_b = state.searchBeanModal.zoneIdList) === null || _b === void 0 ? void 0 : _b.findIndex(zoneId => zoneId === zone.zoneID);
      if (zoneIdxToRemove !== -1 && zoneIdxToRemove !== undefined) (_c = state.searchBeanModal.zoneIdList) === null || _c === void 0 ? void 0 : _c.splice(zoneIdxToRemove, 1);
      insertDistrictByZoneId(zone.zoneID, district.districtID);
      if (state.searchBeanModal.districtIdList) state.searchBeanModal.districtIdList = [...state.searchBeanModal.districtIdList, district.districtID];
    }
    //Case single district
    if (((_d = state.searchBeanModal.districtIdList) === null || _d === void 0 ? void 0 : _d.length) === 1 && !((_e = state.searchBeanModal.zoneIdList) === null || _e === void 0 ? void 0 : _e.length)) {
      state.searchBeanModal.zoneId = null;
      state.searchBeanModal.zoneURL = null;
      state.searchBeanModal.zoneIdList = [];
    }
    if (state.searchBeanModal.zoneIdList && state.searchBeanModal.zoneIdList.length === 1) {
      // @ts-ignore
      state.searchBeanModal.zoneURL = (_f = state.zoneList.find(z => z.zoneID === state.searchBeanModal.zoneIdList[0])) === null || _f === void 0 ? void 0 : _f.zoneURL;
    }
    //Handling the districtUrl and districtId
    else if (isSingleDistrictSelected.value) {
      state.searchBeanModal.districtURL = district.zoneURL;
      state.searchBeanModal.districtId = district.districtID;
    } else {
      state.searchBeanModal.districtURL = null;
      state.searchBeanModal.districtId = null;
    }
    updatePlaceNameAction();
  };
  var removeDistrict = (zone, updatePlaceNameAction, district) => {
    var _a, _b, _c;
    if (!(Object.keys(state.districtSelected).length > 0) && !areAllDistrictsSelected(zone.zoneID)) {
      return;
    }
    if (district) {
      //Removing the zone url and id since the districtIds will be inserted in the url
      state.searchBeanModal.zoneId = null;
      state.searchBeanModal.zoneURL = null;
      //By default, we will also remove the districts URL and id
      state.searchBeanModal.districtURL = null;
      state.searchBeanModal.districtId = null;
      if (!state.districtSelected[zone.zoneID]) {
        //In this scenario the district of the selected zone are all selected just visibly...
        //... which means that the districtObj is empty for that given zoneId
      } else {
        state.districtSelected[zone.zoneID].splice(state.districtSelected[zone.zoneID].indexOf(district.districtID), 1);
      }
      if (state.searchBeanModal.districtIdList)
        //Removing the districtId from the array
        state.searchBeanModal.districtIdList = [...state.searchBeanModal.districtIdList.filter(districtId => district.districtID !== districtId)];
      updatePlaceNameAction();
      /*
      * Case: zone with all districts selected
      *   1) zoneId will be removed
      *   2) remaining district will be added
      * */
      if (areAllDistrictsSelected(zone.zoneID)) {
        removeZone(zone, () => {
          console.log("");
        }, true);
        var districtsToAdd = state.districtsObj[district.zoneID].filter(districtToAdd => districtToAdd.districtID !== district.districtID).map(d => d.districtID);
        if (state.searchBeanModal.districtIdList) state.searchBeanModal.districtIdList = [...state.searchBeanModal.districtIdList, ...districtsToAdd];
        state.districtSelected[zone.zoneID] = districtsToAdd;
        updatePlaceNameAction();
        return;
      }
      /**
       * Case: There is one zone with districts selected
       * */
      if (Object.keys(state.districtSelected).length === 1) {
        /*Case: There is only one district in the selected zone */
        if (Object.values(state.districtSelected)[0].length === 1) {
          var lastDistrict = state.districtsObj[zone.zoneID].find(district => district.districtID === state.districtSelected[zone.zoneID][0]);
          state.searchBeanModal.districtURL = lastDistrict === null || lastDistrict === void 0 ? void 0 : lastDistrict.zoneURL;
          state.searchBeanModal.districtId = lastDistrict === null || lastDistrict === void 0 ? void 0 : lastDistrict.districtID;
          updatePlaceNameAction();
        }
      }
      /*
      * Case: Zone without districts
      * */
      if (!getDistrictSelectedLengthByZoneId(zone.zoneID)) {
        state.searchBeanModal.districtURL = null;
        state.searchBeanModal.districtId = null;
        if (state.searchBeanModal.zoneId || ((_a = state.searchBeanModal.zoneIdList) === null || _a === void 0 ? void 0 : _a.length) === 1) state.searchBeanModal.zoneURL = zone.zoneURL;
        // $delete(state.districtSelected, zone.zoneID)
        delete state.districtSelected[zone.zoneID];
        removeZone(zone, updatePlaceNameAction, true);
        //Removing all the
      }
      /*
      * Case: One zone selected with other districts selected too
      * */
      if (state.searchBeanModal.zoneIdList && state.searchBeanModal.zoneIdList.length === 1 || state.searchBeanModal.zoneId) {
        // @ts-ignore
        state.searchBeanModal.zoneURL = (_b = state.zoneList.find(z => z.zoneID === state.searchBeanModal.zoneIdList[0])) === null || _b === void 0 ? void 0 : _b.zoneURL;
      }
    }
    //Not a district
    else {
      var districtsToRemove = state.districtSelected[zone.zoneID];
      // $delete(state.districtSelected, zone.zoneID)
      delete state.districtSelected[zone.zoneID];
      if (isSingleDistrictSelected.value) {
        var [zoneId, districtIds] = Object.entries(state.districtSelected)[0];
        var lastSingleDistrict = state.districtsObj[+zoneId].find(district => district.districtID === districtIds[0]);
        state.searchBeanModal.districtURL = lastSingleDistrict === null || lastSingleDistrict === void 0 ? void 0 : lastSingleDistrict.zoneURL;
        state.searchBeanModal.districtId = lastSingleDistrict === null || lastSingleDistrict === void 0 ? void 0 : lastSingleDistrict.districtID;
      }
      if (districtsToRemove) state.searchBeanModal.districtIdList = ((_c = state.searchBeanModal.districtIdList) === null || _c === void 0 ? void 0 : _c.filter(districtId => !districtsToRemove.includes(districtId))) || [];
      updatePlaceNameAction();
    }
  };
  return Object.assign(Object.assign({}, toRefs(state)), {
    //Computed
    isSingleDistrictSelected,
    isAnyDistrictSelected,
    selectedDistrictLength,
    partialSelectedDistrictLength,
    allDistrictSelectedPerZone,
    //Methods
    convertEnergyClassFilter,
    convertFloor,
    resetSearchBeanZonesAndLocalities,
    updateSearchModal,
    updateSearchModalByPlace,
    updateSearchModalAndPlace,
    fixSearchBean,
    initZonesAndLocalities,
    areAllDistrictsSelected,
    isSingleDistrictByZoneId,
    isZoneOrLocalitySelected,
    isZoneWithoutDistrict,
    areZonesAndLocalitiesEmpty,
    areZonesAndLocalitiesFilled,
    getSingleSelectedZone,
    getSingleSelectedDistrict,
    getZoneById,
    getDistrictById,
    getDistrictLengthByZoneId,
    getDistrictSelectedLengthByZoneId,
    resetZoneAndLocalities,
    addZone,
    removeZone,
    isZoneSelected,
    isLocationSelected,
    isDistrictSelected,
    addLocation,
    removeLocation,
    insertDistrictByZoneId,
    insertBulkDistrictByZoneId,
    onPlaceLIClick,
    onDistrictClick,
    addDistrict,
    removeDistrict
  });
}